<template>
  <span class="risk-label" v-if="risk">{{ risk['crashes_predicted_per_hour'] }}</span>
  <span class="risk-label" v-else-if="score">{{ score }}</span>
</template>

<script>
export default {
  props: [ 'risk', 'score' ]
}
</script>

<style>
.risk-label {
  border-radius: 10px;
  background: #333;
  padding: 2px 20px;
  color: #fff;
  height: fit-content;
}
</style>
